import React, { Fragment, useState } from 'react'
import LoaddingCommentComponent from './LoaddingCommentComponent'
import { STATUS } from '../../Constants'
import { CSVLink } from 'react-csv'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBoxesPacking, faCalendar, faChevronDown, faDownLong, faEnvelope, faMagnifyingGlass, faReply, faXmark } from '@fortawesome/free-solid-svg-icons'
import { Backdrop, Fade, Modal } from '@mui/material'
import { useDebounce } from 'use-debounce'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { getLanguage } from '../../RTK/Slice/UserSlice'
import { getId, getPoints, getToken, getUsername } from '../../RTK/Slice/Auth/AuthSlice'
import { Tooltip } from 'react-tooltip'
import { toast } from 'react-toastify'
import { replyCommentAPI } from '../../RTK/Slice/PageSlice'
import ExtractModal from './ExtractModal'
import { extractDataFromDBAPI } from '../../RTK/Slice/Extract/ExtractDataFromDBSlice'
import { useParams } from 'react-router-dom' ; 
import EgyptPng from "./../../Images/egypt.png" ; 
import IraqPng from "./../../Images/iraq.png" ; 
import UaePng from "./../../Images/uae.png" ; 
import UsaPng from "./../../Images/Flag_of_the_United_States.png" ; 
import yamenPng from "./../../Images/yemen.webp" ; 
import candaPng from "./../../Images/canda.png" ; 
import omanPng from "./../../Images/oman.png" ; 
import libyaPng from "./../../Images/libya.png" ; 
import KuweitPng from "./../../Images/Kuwait.png" ; 
import moroocoPng from "./../../Images/morocco.png" ; 
import qatarPng from "./../../Images/qatar.png" ; 
import algeriaPng from "./../../Images/algeria.png" ; 
import saudiPng from "./../../Images/sauid.png" ; 
import jordonpng from "./../../Images/jordon.png" ; 
import lebnanpng from "./../../Images/lebnan.png"
import syria from "./../../Images/syria.png"
import palestine from "./../../Images/palestine.png"

const ListComments = ({comments , statusOfComments , replay=false , message=false}) => {


    // For Save Data
    const [excelData , setExcelData ] = useState([]) ; 

    // For Render Choose Country Modal
    const [chooseCountryModal , toogleCountryModal] = useState(false) ; 

    // For Control Show Country List
    const [showCountryList , setShowCountryList] = useState(false) ; 

    // For Choose Country state
    const [selectCountry , setSelecCountry] = useState({}) ; // {Country , value}


    const countryModalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        height : 250,
        maxWidth : "100%",
        p: 6,
        };

        // For Open Country Modal
        const handleOpenCountryModal = ()=>{
            toogleCountryModal(true) ; 
        }

        // For Close Country Modal
        const handleCloseCountryModal = ()=>{
            toogleCountryModal(false)
            setSelecCountry({}) ; 
            setShowCountryList(false) ; 
        }

    // For Store ID user For Replay
    const [allUserID , setAllUserID] = useState([]) ; 

    // For Control Show Time Mneu 
    const [showTime , setShowTime] = useState(false) 

    // For get points
    const points =  useSelector((state) => state.AdminSlice?.userProfile?.user?.points);

    // For Store Selected Item
    const [selected , setSelected] = useState([]) ; 

    // For Selected ID
    const [selectedID , setSelectedID] = useState([]) ; 

    // For Store Choose Time
    const [timer , setTime] = useState("") ; 

    // For Make Translation
    const {t} = useTranslation() ;

    // For Detect Language
    const language = useSelector(getLanguage) ; 

    // For Access Search In DB Data 
    const {data , status} = useSelector(state => state.ExtractDataFromDBSlice) ;     


    const [activeLang ] = useState(language ? language : 'ar') ;

    // For Rely Comment Field
    const [replyComment , setReplyComment] = useState('') ; 
    

    // For Modal Style
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        p: 4,
        };
    

    // For Control Reply Modal
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => {setOpen(false) ; setShowTime(false)};

    // For Control Message Modal
    const [openMessage, setOpenMessage] = useState(false);
    const handleMessageOpen = () => setOpenMessage(true);
    const handleMessageClose = () => setOpenMessage(false);

    // for Get Username
    const username = useSelector(getUsername) ; 

    
    // For Control Extract Modal
    const [openExtractModal, setOpenExtractModal] = useState(false);

    // For Get User ID 
    const userID = useSelector(getId) ; 

    // For Get Data From DB
    const handleExtractOpen = () => {
        if(selectedID.length > 0 && selectCountry.value ){
            if(points >= selectedID.length){
                
                toogleCountryModal(false) ; 
                setOpenExtractModal(true) ; 
                dispatch(extractDataFromDBAPI({token , userId : userID , selectedID , username , db_name : selectCountry.value })) ;
                setSelecCountry({}) ;
            }
            else{
                toast.info("You don't have enough points")
            }

            
        }else{
            toast.info("Please Choose IDs")
        }
    };


    const handleExtractClose = () => setOpenExtractModal(false);

    // For Control Show Dropdown menu OS
    const [menuOS , setMenuOS] = useState(false) ; 

    // For Set Os Filter
    const [typeOS , setTypeOS] = useState('all')

    // For Save Copy
    const [copyText , setCopyText] = useState("");
    
    
    // For CheckBox Choose 
    const checkBoxHandler = (e , ID)=>{

        let isSelectd = e.target.checked ;
        let value = e.target.value ; 
        if (isSelectd){
            setSelected([...selected , value])
            setSelectedID([...selectedID , ID]);
        }else{
            setSelected((prev)=>{
                return prev.filter((id)=>{
                    return id !== value
                })
            })
            setSelectedID((prevDate)=>{
                return prevDate.filter((id)=>{
                    return id !== ID
                })
            })
        }
    }


    // For Select All Data 
    const selectAllHandler = (e)=>{
        let selectAll = e.target.checked ;
        if(selectAll){
        setSelected(comments
        .filter((item)=>value === ''  ? item : item?.message.toLowerCase().includes(value))
        .filter((item)=>typeOS === 'all' ? item : item?.application?.name.includes(typeOS))
        .map((item)=>item.id)) ; 

        // For Save IDs 
        setSelectedID(comments
            .filter((item)=>value === ''  ? item : item?.message.toLowerCase().includes(value))
            .filter((item)=>typeOS === 'all' ? item : item?.application?.name.includes(typeOS))
            .map((item)=>item?.from?.id)) ;
        
        // For Save Comment Data
        setExcelData(comments
            .filter((item)=>value === ''  ? item : item?.message.toLowerCase().includes(value))
            .filter((item)=>typeOS === 'all' ? item : item.application.name.includes(typeOS))
            .map((item)=>Object.assign({},{comment_id : item?.id , name :item?.from?.name , content :item?.message , os : item?.application?.name , user_id : item?.from?.id }))) ; 
        
        }else{
            setSelected([])
            setSelectedID([])
        }
    }

    // For Copy Text Handler
    const copyTextHandler = (text)=>{
        setCopyText(text) ; 
    }

    const pageToken = useParams() ; 


    // For Store Search Input
    const [search , setSearch] = useState("") ; 
    const [value] = useDebounce(search , 300) ;

    // For Get Token
    const token = useSelector(getToken) ; 

    // For Dispatch Action
    const dispatch = useDispatch() ; 

    // For Render Reply Modal
    const renderReplayModal = ()=>{
        return (
            <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                timeout: 300,
                },
            }}
            >
            <Fade in={open}>
                <div className='k-modal my-font' style={style}>

                    <div className='head'>
                        <div className='left'>
                            <h3>Reply Comments</h3>
                            <p>You can reply to all comment you selected</p>
                        </div>
                        <div className='right' onClick={handleClose}><FontAwesomeIcon  icon={faXmark} /></div>
                    </div>
                    <div className='body'>
                        <div className='write-message-con'>
                            <label className='' htmlFor='message-input'>Reply </label>
                            <textarea value={replyComment} onChange={(e)=>setReplyComment(e.target.value)}  autoFocus placeholder={"Please write reply"} className='message-field' id='message-input'></textarea>
                        </div>

                        <div className='choose-time' onClick={()=>setShowTime(!showTime)}>
                            <p>{timer ? `Between ${timer.t1}0 sec and ${timer.t2}0 sec`: "Time Between Replys"}</p>
                            <FontAwesomeIcon icon={faChevronDown} />
                            
                            <ul className={`list-items ${showTime ? "list-items-show": "" }`}>
                            <li onClick={()=>setTime({t1 : 6 , t2 : 12})} >Between 1 min and 2 min</li>
                            <li onClick={()=>setTime({t1 : 12 , t2 : 21})} >Between 2 min and 3.5 min</li>
                            <li onClick={()=>setTime({t1 : 18 , t2 : 24})} >Between 3 min and 4 min</li>
                            <li onClick={()=>setTime({t1 : 24 , t2 : 30})} >Between 4 min and 5 min</li>
                            <li onClick={()=>setTime({t1 : 6 , t2 : 24})} >Between 1 min and 4 min</li>
                            <li onClick={()=>setTime({t1 : 12 , t2 : 36})} >Between 2 min and 6 min</li>
                            <li onClick={()=>setTime({t1 : 18 , t2 : 48})} >Between 3 min and 8 min</li>
                            <li onClick={()=>setTime({t1 : 30 , t2 : 66})} >Between 5 min and 11 min</li>
                            <li onClick={()=>setTime({t1 : 60 , t2 : 96})} >Between 10 min and 16 min</li>
                            <li onClick={()=>setTime({t1 : 72 , t2 : 114})} >Between 12 min and 19 min</li>
                            <li onClick={()=>setTime({t1 : 120 , t2 : 168})} >Between 20 min and 28 min</li>
                            </ul>
                            
                            
                        </div>

                    </div>

                    <div className='btn'>
                        <button onClick={replyCommentHandler} >Reply</button>
                    </div>

                </div>
                
            </Fade>
        </Modal>
        )
    }

    // For Render Message Modal
    const renderMessageModal = ()=>{
        return (
            <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={openMessage}
            onClose={handleMessageClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                timeout: 300,
                },
            }}
            >
            <Fade in={openMessage}>
                <div className='k-modal my-font' style={style}>

                    <div className='head'>
                        <div className='left'>
                            <h3>{t('messageBtn')}</h3>
                            <p>{t('messageReply')}</p>
                        </div>
                        <div className='right'><FontAwesomeIcon onClick={handleMessageClose} icon={faXmark} /></div>
                    </div>
                    <div className='body'>
                        <div className='write-message-con'>
                            <label className='' htmlFor='message-input'>{t('replay')} </label>
                            <textarea  autoFocus placeholder={t('messageBtn')} className='message-field' id='message-input'></textarea>
                        </div>
                        <div className='time-con'>
                            <div className='time-left'>
                                <p>Start date (Min)</p>
                                <div className='time-field'>
                                    <FontAwesomeIcon icon={faCalendar} />
                                    <input placeholder='Range' />
                                </div>
                            </div>
                            
                            <span>-</span>
                            <div className='time-right'>
                                <p>End date (Min)</p>
                                <div className='time-field'>
                                    <FontAwesomeIcon icon={faCalendar} />
                                    <input placeholder='Range' />
                                </div>
                            </div>
                            
                        </div>
                    </div>

                    <div className='btn'>
                        <button>{t('messageBtn')}</button>
                    </div>

                </div>
                
            </Fade>
        </Modal>
        )
    }

    // For Render Message Modal
    const renderChoooseCountryModal = ()=>{
        return (
            <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={chooseCountryModal}
            onClose={handleCloseCountryModal}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                timeout: 300,
                },
            }}
            >
            <Fade in={chooseCountryModal}>
                <div className='k-modal my-font' style={countryModalStyle}>

                    <div className='head'>
                        <div className='left'>
                            <h3>Extract Data</h3>
                            <p>Please select the country you want to search in.</p>
                        </div>
                        <div className='right'><FontAwesomeIcon onClick={handleCloseCountryModal} icon={faXmark} /></div>
                    </div>
                    <div className='body'>
                        <div className='write-message-con'>
                            <label className='' htmlFor='message-input'>Choose Country </label>

                                <div className='choose-time' onClick={()=>setShowCountryList(!showCountryList)}>
                                <p>{selectCountry.country ? `${selectCountry.country}`: "Country"}</p>
                                <FontAwesomeIcon icon={faChevronDown} />
                                
                                <ul className={`list-items ${showCountryList ? "list-items-show": "" }`}>
                                    {/*<li onClick={()=>setSelecCountry({country : "Egypt" , value : "egy_db"})}  > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={EgyptPng} alt='flag' /> Egypt</li>*/}
                                    <li onClick={()=>setSelecCountry({country : "Algeria" , value : "algeria_db"})} ><img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={algeriaPng} alt='flag' /> Algeria</li>
                                    <li onClick={()=>setSelecCountry({country : "Canada" , value : "canada_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={candaPng} alt='flag' /> Canada</li>
                                    <li onClick={()=>setSelecCountry({country : "Egypt" , value : "extra_egy_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={EgyptPng} alt='flag' /> Egypt </li>
                                    <li onClick={()=>setSelecCountry({country : "Iraq" , value : "iraq_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={IraqPng} alt='flag' /> Iraq</li>
                                    <li onClick={()=>setSelecCountry({country : "Jordan" , value : "jordan_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={jordonpng} alt='flag' /> Jordan</li>
                                    <li onClick={()=>setSelecCountry({country : "Kuwait" , value : "kuwait_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={KuweitPng} alt='flag' /> Kuwait</li>
                                    <li onClick={()=>setSelecCountry({country : "Lebanon" , value : "lebanon_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={lebnanpng} alt='flag' /> Lebanon </li>
                                    <li onClick={()=>setSelecCountry({country : "Libya" , value : "libya_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={libyaPng} alt='flag' /> Libya</li>
                                    <li onClick={()=>setSelecCountry({country : "Morocco" , value : "morocco_db"})}> <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={moroocoPng} alt='flag' /> Morocco</li>
                                    <li onClick={()=>setSelecCountry({country : "Oman" , value : "oman_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={omanPng} alt='flag' /> Oman</li>
                                    <li onClick={()=>setSelecCountry({country : "Qatar" , value : "qatar_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={qatarPng} alt='flag' /> Qatar</li>
                                    <li onClick={()=>setSelecCountry({country : "Saudi Arabia" , value : "saudi_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={saudiPng} alt='flag' /> Saudi Arabia</li>
                                    <li onClick={()=>setSelecCountry({country : "United Arab Emirates (UAE)" , value : "uae_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={UaePng} alt='flag' /> United Arab Emirates (UAE)</li>
                                    <li onClick={()=>setSelecCountry({country : "United States of America (USA)" , value : "usa_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={UsaPng} alt='flag' /> United States of America (USA)</li>
                                    <li onClick={()=>setSelecCountry({country : "Yemen" , value : "yemen_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={yamenPng} alt='flag' /> Yemen</li>
                                    <li onClick={()=>setSelecCountry({country : "Syria" , value : "syria_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={syria} alt='flag' /> Syria</li>
                                    <li onClick={()=>setSelecCountry({country : "Palestine" , value : "palestine_db"})} > <img style={{width : "20px" , height : "15px" , margin :"0px 10px"}} src={palestine} alt='flag' /> Palestine</li>
                                </ul>
                                
                                
                            </div>

                        </div>
                    </div>

                    <div className='btn'>
                        <button onClick={handleExtractOpen}>Extract</button>
                    </div>

                </div>
                
            </Fade>
        </Modal>
        )
    }


    const renderExtractModal = ()=>{
        return( 
            <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={openExtractModal}
            onClose={handleExtractClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                timeout: 300,
                },
            }}
            >

            <Fade in={openMessage}>
                <ExtractModal closeModal={handleExtractClose} data={data} status={status} />
                
            </Fade>
        </Modal>
    )
    }

    // For Get Random Number Between 1min and 2 min
    function getRandomBetween1And2Minutes(args) {
        // Convert minutes to milliseconds
        const min = args.t1 * 10000; // 1 minute in milliseconds
        const max = args.t2  * 10000; // 2 minutes in milliseconds
        
        // Generate random number between min and max
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    // For Reply Comment Handler
    const replyCommentHandler = ()=>{
        if(replyComment  && timer){
            let time = 0;
            for(let i = 0 ; i < selected.length ;i++) {
                setTimeout(()=>{
                    dispatch(replyCommentAPI({token , userId : excelData[i]?.user_id , comment : replyComment ,userToken : pageToken.pageToken , commentId : selected[i] })) ; 

                } , time)
                time += getRandomBetween1And2Minutes(timer) ; 
            }
            handleClose()
            const id = toast.loading("Please wait...")
            setTimeout(()=>{
                toast.update(id, {
                    render: "Operation successful!",
                    type: "success",
                    isLoading: false, // Stop the loading spinner
                    autoClose: 3000, // Automatically close after 3 seconds
                  });
            } , time)
            setReplyComment("")
        }else{
            toast.info("Please Write Comment")
        }
        
    }


  return (
    <div className='all-comment-page'>

        { replay ?  renderReplayModal() :""}
        {message ? renderMessageModal() :""}
        {renderExtractModal()}
        {renderChoooseCountryModal()}

        <div className='tools-filter'>
            <div style={{display: "flex" , alignItems : "center"}}>
            
                <div className='search-bar'>
                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                    <input value={search} onChange={(e)=>{ setSearch(e.target.value)}} placeholder={`${t('search')}`} />
                </div>
                <div className='os-drop-menu' onClick={()=>{setMenuOS(!menuOS)}}>
                    <p > {typeOS ==='all'? 'All Devices' : typeOS ==='Facebook for iPhone' ? 'IPhone' : typeOS ==='Facebook Lite' ? 'Facebook Lite' : typeOS === 'Facebook for Android'?'Android' :"" }  <FontAwesomeIcon icon={faChevronDown} /></p>
                    <ul className={`type-os-dropdown ${menuOS  ? 'type-os-dropdown-active' : 'type-os-dropdown-inactive'} ${activeLang === 'en' ? 'en' :'ar' } `}>
                        <li onClick={()=>{setTypeOS('all');setMenuOS(false)}}>All Devices </li>
                        <li onClick={()=>{setTypeOS('Facebook for iPhone');setMenuOS(false)}}>Facebook for iPhone </li>
                        <li onClick={()=>{setTypeOS('Facebook for Android');setMenuOS(false)}} >Facebook for Android </li>
                        <li onClick={()=>{setTypeOS('Facebook Lite');setMenuOS(false)}}>Facebook Lite </li>
                    </ul>
                </div>
                
            </div>
            <div className='btn-group'>
                <CSVLink data={excelData}><span >  <FontAwesomeIcon icon={faDownLong} /></span></CSVLink>
                
                {message ? (<button className='btn-message' onClick={handleMessageOpen} >{t('messageBtn')} <FontAwesomeIcon icon={faEnvelope} /> </button>) :""}
                {replay ? (<button className='btn-replay' onClick={handleOpen}>Reply <FontAwesomeIcon icon={faReply} /> </button>) : ""}

                <button className='btn-replay' onClick={handleOpenCountryModal}> Extract Data {selected.length !== 0 ?`(${selected.length})` :""} <FontAwesomeIcon icon={faBoxesPacking} /> </button>
                
            </div>
        </div>
        
        <div className='all-co'>
            <h2 style={{margin: "5px 0px"}}>Number of comments extracted {comments.length}</h2>
            <div className='comment-item-head'>
                <div className='item-check'><input onChange={selectAllHandler} type="checkbox" /> </div>
                <div className='item-comment_id hide-mobile'  >Comment ID</div>
                <div className='item-comment_user'>User</div>
                <div className='item-content'>Content</div>
                <div className='item-os'>OS</div>
                <div className='item-info-user'>User ID</div>
            </div>

            {
                statusOfComments === STATUS.LOADDING ? (
                    <Fragment>
                        <LoaddingCommentComponent/>
                        <LoaddingCommentComponent/>
                        <LoaddingCommentComponent/>
                        <LoaddingCommentComponent/>
                    </Fragment>
                ) :""
            }

            {
                
                comments.length === 0 ? <h2 style={{textAlign : "center" , marginTop : "20px"}}>No Comments</h2>
                : 
                comments.filter((item)=> value === '' && typeOS ==='all' ? item : item?.message.toLowerCase().includes(value))
                .filter((item)=>typeOS === 'all' ? item : item?.application?.name.includes(typeOS))
                .map((item)=>{
                    return (
                        <div key={item?.id} className='comment-item-body'>
                            <div className='item-check nor'><input value={item?.id} checked={selected.includes(item?.id)} onChange={(e)=>checkBoxHandler(e , item?.from?.id)} type="checkbox"  /></div>
                            <div className='item-comment_id nor hide-mobile' data-tooltip-id="my-tooltip" data-tooltip-delay-show={800}  data-tooltip-content={item?.id} onClick={()=>copyTextHandler(item?.id)} >{item?.id ? `${item?.id.slice(0 ,12)}...`  :""}</div>
                            <div className='item-comment_user nor' data-tooltip-id="my-tooltip" data-tooltip-delay-show={800}  data-tooltip-content={item?.from?.name} onClick={()=>copyTextHandler(item?.from?.name)} >{item?.from?.name ?item?.from?.name?.length > 18 ? `${item?.from?.name.slice(0 ,15)}...` : item?.from.name :""}</div>
                            <div className='item-content nor' data-tooltip-id="my-tooltip" data-tooltip-delay-show={800}  data-tooltip-content={item?.message} onClick={()=>copyTextHandler(item?.message)}>{item?.message ?item.message.length > 20 ?` ${item?.message.slice(0 ,20)}...` :item?.message : ""}</div>
                            <div className='item-os nor' onClick={()=>copyTextHandler(item?.application?.name)}>{item?.application?.name ?item?.application?.name  :""}</div>
                            <div className='item-info-user nor' >{item?.from?.id}</div>
                        </div>
                    )
                }) 
                
            }

            


            {/* For Loadding */}
            {/* <Skeleton count={6} style={{width : "1020px", marginBottom : "4px" , height : "45px" , maxWidth : "100%" , borderRadius : "7px"}} />*/ }

            
            <Tooltip id="my-tooltip" />
        </div>
    </div>
  )
}

export default ListComments
